module.exports = __webpack_public_path__ + "037d830416495def72b7881024c14b7b.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-700.woff2
// module id = 671
// module chunks = 0